import React from 'react';

export type Props = {
  className?: string;
  color?: string;
  height?: number;
  onClick?(): void;
  width?: number;
};

export const UspsCheckMark = React.memo((props: Props) => {
  const {
    width = 14,
    height = 17,
    className,
    color = 'var(--green)',
    onClick,
  } = props;

  const style = {
    minWidth: width,
    minHeight: height,
  };

  return (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      style={style}
      viewBox='0 0 14 17'
    >
      <path
        d='M0.56875 2.2824L6.335 0.12242C6.76375 -0.0349878 7.2275 -0.0349878 7.65625 0.12242L13.4313 2.2824C13.7725 2.41357 14 2.73713 14 3.10442V6.87345C14 9.65431 12.8012 12.2953 10.71 14.1229L7.72625 16.7289C7.30625 17.0962 6.685 17.0962 6.27375 16.7289L3.29 14.1229C1.19875 12.2865 0 9.64557 0 6.8647V3.10442C0 2.73713 0.2275 2.41357 0.56875 2.2824ZM6.23875 8.63991L4.80375 7.20575C4.41875 6.80349 3.77125 6.79474 3.36875 7.17952C2.96625 7.56429 2.9575 8.21141 3.3425 8.61367C3.3425 8.61367 3.36 8.63116 3.36875 8.63991L5.52125 10.7911C5.915 11.1847 6.5625 11.1847 6.95625 10.7911L11.2612 6.48867C11.6637 6.1039 11.6725 5.45678 11.2875 5.05452C10.9025 4.65225 10.255 4.64351 9.8525 5.02828C9.8525 5.02828 9.835 5.04577 9.82625 5.05452L6.23875 8.63991Z'
        fill={color}/>

    </svg>
  );
});

UspsCheckMark.displayName = 'UspsCheckMark';
